import { EventInfoFragment } from '@graphql/types';

type Name = string | null | undefined;

export const getInitials = (input: Name | { firstName: Name; lastName: Name }): string => {
  input = input || '';
  if (!input) {
    return '';
  }

  if (typeof input === 'object') {
    return [input.firstName, input.lastName]
      .filter(n => n && n.length > 0)
      .map(name => name![0])
      .join('');
  }

  return input
    .split(' ')
    .map(n => n[0])
    .join('');
};

export const getFirstLastNameFromString = (name: string) => {
  const [firstName, lastName] = name.split(' ');
  return {
    firstName: firstName || '',
    lastName: lastName || ''
  };
};

export const getFullName = (...names: (string | null | undefined)[]) => {
  return names.filter(n => n).join(' ');
};

export const getEventDisplayFromNames = (
  primary: EventInfoFragment['ownerFirstName'],
  secondary: EventInfoFragment['fianceeFirstName']
) => {
  return [primary, secondary].filter(name => name).join(' & ');
};
